import {Component, Inject} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommentDialogModel } from './comment-dialog.model';

@Component({
  selector: 'cm-delete-with-comment-dialog',
  template: `
    <h1 mat-dialog-title>
      <i class="fas fa-exclamation-triangle mr-3"></i>
      {{data?.title || 'Please confirm your action'}}
    </h1>
    <div mat-dialog-content>
      <mat-list class="mat-dialog-data-list">
          <h3 mat-subheader>{{data?.subtitle || 'Are you sure?'}}</h3>
          <mat-list-item>
            <textarea [readonly]="dialogData.readOnly" placeholder="{{dialogData.placeholder || 'Enter comment here'}}" matInput [(ngModel)]="dialogData.comment" style="min-height: 150px "></textarea>
          </mat-list-item>
      </mat-list>
    </div>
    <div mat-dialog-actions class="justify-content-center">
	    <button mat-raised-button mat-dialog-close cdkFocusInitial [mat-dialog-close]="false">Cancel</button>
        <button [disabled]="dialogData.commentRequired && dialogData.comment.length === 0" (click)="confirm()" mat-raised-button color="warn">{{dialogData.confirmBtnText || 'Yes, delete!'}}</button>
    </div>
  `,
  host: {'class': 'mat-dialog-warn'}
})
export class DeleteCommentDialogComponent {
  dialogData: CommentDialogModel;

  constructor(public dialogRef: MatDialogRef<DeleteCommentDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {

    this.dialogData = Object.assign({}, data);
    this.dialogData.comment = (this.dialogData.comment) ? this.dialogData.comment : '';
  }

  confirm() {
    this.dialogRef.close({comment: this.dialogData.comment});
  }
}
